const affDomains = {
  "betway178.biz": "B129129", //測試用
  "vndbetway.com": "B123540",
  "vietnambetway.com": "B123541",
  "bway227.com": "B123952",
  "bw1230.com": "B120003",
  "bw1886.com": "B123586",
  "bongbway88.com": "B123954",
  "tiyubaba.com": "B120001",
  "bw0880.com": "B120002",
  "bw0883.com": "B123585",
  "bw88dj.com": "B129013",
  "bwvip365.com": "B129129",
  "biwei365vip.com": "B129144",
  "bwayvip365.com": "B129145",
  "bwsvip365.com": "B129160",
  "biweivip365.com":"B129161",
  "bw099.com":"B129199",
  "bw066.com":"B129200",
  "b8l8.com":"B129242",
  "worthy08.com":"B129243",
  "bway389.com":"B129244",
  "bbway69.com ":"B129245",
  "bway-198.com":"B129246",
  "joinbwei.com":"B129258",
  "b88ways.com":"B129259",
  "bwei1u8.com":"B129260",
  "biwei111.com":"B129261",
  "88biwei.com":"B129262",
}

export default affDomains;
